import React, { useState } from 'react';

const CalendarioPage: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  // Eventos de ejemplo
  const eventos = [
    {
      id: 1,
      fecha: '2025-01-15',
      titulo: 'MASCLETA PLAZA DEL AYUNTAMIENTO',
      ubicacion: 'Valencia Centro',
      tipo: 'pirotecnia',
      hora: '14:00'
    },
    {
      id: 2,
      fecha: '2025-01-18',
      titulo: 'BODA ELEGANTE - FAMILIA GARCÍA',
      ubicacion: 'Jardines de Viveros',
      tipo: 'boda',
      hora: '22:30'
    },
    {
      id: 3,
      fecha: '2025-01-22',
      titulo: 'FIESTA CORPORATIVA EMPRESA XYZ',
      ubicacion: 'Hotel Las Arenas',
      tipo: 'corporativo',
      hora: '20:00'
    },
    {
      id: 4,
      fecha: '2025-01-25',
      titulo: 'DJ PROJECTE - SESIÓN EN VIVO',
      ubicacion: 'Café Central',
      tipo: 'dj',
      hora: '21:00'
    },
    {
      id: 5,
      fecha: '2025-02-02',
      titulo: 'CASTILLO DE FUEGOS ARTIFICIALES',
      ubicacion: 'Ciudad de las Artes y Ciencias',
      tipo: 'pirotecnia',
      hora: '23:00'
    },
    {
      id: 6,
      fecha: '2025-02-08',
      titulo: 'CELEBRACIÓN ANIVERSARIO',
      ubicacion: 'Playa de la Malvarosa',
      tipo: 'celebracion',
      hora: '19:30'
    },
    {
      id: 7,
      fecha: '2025-02-14',
      titulo: 'EVENTO SAN VALENTÍN',
      ubicacion: 'Terraza Skybar',
      tipo: 'dj',
      hora: '22:00'
    },
    {
      id: 8,
      fecha: '2025-02-20',
      titulo: 'MASCLETA ESPECIAL FALLAS',
      ubicacion: 'Plaza de la Virgen',
      tipo: 'pirotecnia',
      hora: '14:00'
    }
  ];

  const meses = [
    'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
    'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
  ];

  const getTipoColor = (tipo: string) => {
    switch (tipo) {
      case 'pirotecnia': return 'bg-orange-500';
      case 'boda': return 'bg-pink-500';
      case 'corporativo': return 'bg-blue-500';
      case 'dj': return 'bg-purple-500';
      case 'celebracion': return 'bg-green-500';
      default: return 'bg-gray-500';
    }
  };

  const getTipoIcon = (tipo: string) => {
    switch (tipo) {
      case 'pirotecnia': return 'ri-fire-line';
      case 'boda': return 'ri-heart-line';
      case 'corporativo': return 'ri-building-line';
      case 'dj': return 'ri-music-line';
      case 'celebracion': return 'ri-cake-line';
      default: return 'ri-calendar-line';
    }
  };

  // Filtrar eventos por mes y año seleccionado
  const eventosFiltrados = eventos.filter(evento => {
    const fechaEvento = new Date(evento.fecha);
    return fechaEvento.getMonth() === selectedMonth && fechaEvento.getFullYear() === selectedYear;
  });

  // Generar días del mes
  const getDiasDelMes = () => {
    const primerDia = new Date(selectedYear, selectedMonth, 1);
    const ultimoDia = new Date(selectedYear, selectedMonth + 1, 0);
    const diasEnMes = ultimoDia.getDate();
    const primerDiaSemana = primerDia.getDay();
    
    const dias = [];
    
    // Días vacíos al inicio
    for (let i = 0; i < primerDiaSemana; i++) {
      dias.push(null);
    }
    
    // Días del mes
    for (let i = 1; i <= diasEnMes; i++) {
      dias.push(i);
    }
    
    return dias;
  };

  const tieneEvento = (dia: number) => {
    if (!dia) return false;
    const fechaBuscar = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    return eventos.some(evento => evento.fecha === fechaBuscar);
  };

  const getEventosDelDia = (dia: number) => {
    if (!dia) return [];
    const fechaBuscar = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    return eventos.filter(evento => evento.fecha === fechaBuscar);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnia" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                FUEGOS ARTIFICIALES
              </a>
              <a href="/eventos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-16 sm:py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=elegant%20calendar%20and%20event%20planning%20concept%20with%20spectacular%20fireworks%20in%20background%2C%20professional%20event%20management%2C%20golden%20sparks%20and%20lights%2C%20luxury%20event%20planning%20atmosphere%2C%20dramatic%20evening%20sky&width=1920&height=600&seq=calendar1&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 to-gray-800/40"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-wider drop-shadow-2xl px-2">
            CALENDARIO DE
            <span className="block bg-gradient-to-r from-orange-400 via-yellow-400 to-red-500 bg-clip-text text-transparent">
              EVENTOS
            </span>
          </h1>
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
            17 años organizando espectáculos en Valencia
          </p>
        </div>
      </section>

      {/* Calendario Principal */}
      <section className="py-12 sm:py-16 bg-gradient-to-b from-slate-800 to-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Selector de Mes y Año */}
          <div className="flex flex-col md:flex-row items-center justify-between mb-8 sm:mb-12 space-y-4 md:space-y-0">
            <div className="flex items-center space-x-3 sm:space-x-4">
              <button 
                onClick={() => {
                  if (selectedMonth === 0) {
                    setSelectedMonth(11);
                    setSelectedYear(selectedYear - 1);
                  } else {
                    setSelectedMonth(selectedMonth - 1);
                  }
                }}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 text-black rounded-full flex items-center justify-center hover:scale-105 transition-transform duration-300 cursor-pointer flex-shrink-0"
              >
                <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
              </button>
              
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white tracking-wider text-center">
                {meses[selectedMonth]} {selectedYear}
              </h2>
              
              <button 
                onClick={() => {
                  if (selectedMonth === 11) {
                    setSelectedMonth(0);
                    setSelectedYear(selectedYear + 1);
                  } else {
                    setSelectedMonth(selectedMonth + 1);
                  }
                }}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 text-black rounded-full flex items-center justify-center hover:scale-105 transition-transform duration-300 cursor-pointer flex-shrink-0"
              >
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
            </div>

            <div className="flex items-center space-x-2">
              <span className="text-gray-300 text-xs sm:text-sm">TOTAL EVENTOS:</span>
              <span className="bg-yellow-400 text-black px-2 sm:px-3 py-1 rounded-full font-bold text-xs sm:text-sm">
                {eventosFiltrados.length}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Calendario Visual */}
            <div className="lg:col-span-2">
              <div className="bg-black/40 backdrop-blur-sm rounded-2xl p-6 border border-yellow-400/20">
                {/* Días de la semana */}
                <div className="grid grid-cols-7 gap-2 mb-4">
                  {['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'].map((dia) => (
                    <div key={dia} className="text-center text-gray-400 font-semibold text-sm py-2">
                      {dia}
                    </div>
                  ))}
                </div>

                {/* Días del mes */}
                <div className="grid grid-cols-7 gap-2">
                  {getDiasDelMes().map((dia, index) => {
                    const eventosDelDia = getEventosDelDia(dia || 0);
                    return (
                      <div key={index} className="relative">
                        {dia ? (
                          <div className={`h-16 border border-gray-600 rounded-lg flex flex-col items-center justify-center relative cursor-pointer hover:bg-gray-700/50 transition-colors duration-300 ${
                            tieneEvento(dia) ? 'bg-yellow-400/20 border-yellow-400' : ''
                          }`}>
                            <span className="text-white font-semibold">{dia}</span>
                            {eventosDelDia.length > 0 && (
                              <div className="absolute bottom-1 flex space-x-1">
                                {eventosDelDia.slice(0, 2).map((evento, i) => (
                                  <div
                                    key={i}
                                    className={`w-2 h-2 rounded-full ${getTipoColor(evento.tipo)}`}
                                  ></div>
                                ))}
                                {eventosDelDia.length > 2 && (
                                  <div className="w-2 h-2 rounded-full bg-gray-400"></div>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="h-16"></div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Leyenda */}
                <div className="mt-6 flex flex-wrap gap-4">
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 rounded-full bg-orange-500"></div>
                    <span className="text-gray-300 text-sm">Pirotécnica</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 rounded-full bg-pink-500"></div>
                    <span className="text-gray-300 text-sm">Bodas</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                    <span className="text-gray-300 text-sm">Corporativo</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 rounded-full bg-purple-500"></div>
                    <span className="text-gray-300 text-sm">DJ</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    <span className="text-gray-300 text-sm">Celebraciones</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Lista de Eventos */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white mb-6 tracking-wider">
                PRÓXIMOS EVENTOS
              </h3>
              
              {eventosFiltrados.length > 0 ? (
                <div className="space-y-4">
                  {eventosFiltrados.map((evento) => (
                    <div key={evento.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-4 border border-yellow-400/20 hover:border-yellow-400/50 transition-colors duration-300">
                      <div className="flex items-start space-x-3">
                        <div className={`w-3 h-3 rounded-full ${getTipoColor(evento.tipo)} mt-2 flex-shrink-0`}></div>
                        <div className="flex-1">
                          <div className="flex items-center space-x-2 mb-2">
                            <i className={`${getTipoIcon(evento.tipo)} text-yellow-400`}></i>
                            <span className="text-gray-400 text-sm font-medium">
                              {new Date(evento.fecha).toLocaleDateString('es-ES', { 
                                day: 'numeric', 
                                month: 'short' 
                              })}
                            </span>
                          </div>
                          <h4 className="text-white font-semibold text-sm mb-1 leading-tight">
                            {evento.titulo}
                          </h4>
                          <div className="flex items-center space-x-4 text-gray-400 text-xs">
                            <div className="flex items-center space-x-1">
                              <i className="ri-map-pin-line"></i>
                              <span>{evento.ubicacion}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <i className="ri-time-line"></i>
                              <span>{evento.hora}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <i className="ri-calendar-line text-4xl text-gray-500 mb-4"></i>
                  <p className="text-gray-400">No hay eventos programados para este mes</p>
                </div>
              )}

              {/* CTA */}
              <div className="mt-8 bg-gradient-to-r from-yellow-400/20 to-orange-500/20 rounded-xl p-6 border border-yellow-400/30">
                <h4 className="text-white font-bold text-lg mb-2">¿Necesitas un evento?</h4>
                <p className="text-gray-300 text-sm mb-4">Contacta con nosotros para planificar tu espectáculo único</p>
                <a href="/contacto" className="bg-yellow-400 text-black px-6 py-2 rounded-lg font-bold text-sm tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap">
                  SOLICITAR PRESUPUESTO
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Próximos Destacados */}
      {/* REMOVED: Eventos Destacados section */}

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
            {/* Logo y Descripción */}
            <div className="lg:col-span-2">
              <h3 className="text-white text-2xl font-serif font-bold mb-4">
                ESPECTÁCULOS BRONCHÚ
                <span className="text-yellow-400 text-lg">.</span>
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Especialistas en pirotécnica profesional y entretenimiento con más de 25 años de experiencia creando momentos únicos e inolvidables.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>

            {/* Enlaces Rápidos */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">SERVICIOS</h4>
              <ul className="space-y-3">
                <li><a href="/pirotecnia" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">FUEGOS ARTIFICIALES</a></li>
                <li><a href="/eventos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">EVENTOS</a></li>
                <li><a href="/videos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">GALERÍA</a></li>
                <li><a href="/calendario" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">CALENDARIO</a></li>
              </ul>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">CONTACTO</h4>
              <ul className="space-y-3">
                <li className="text-gray-300">693 812 675</li>
                <li className="text-gray-300">info@espectaculosbronchu.es</li>
                <li className="text-gray-300">VALENCIA, ESPAÑA</li>
                <li><a href="/contacto" className="text-yellow-400 hover:underline cursor-pointer">SOLICITAR PRESUPUESTO</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0">
              © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS.
            </p>
            
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CalendarioPage;
